import { ShiftBreakResponse } from '@/types/service-response'
import moment from 'moment'

export class ShiftBreak {
  public constructor (
    readonly id: number,
    readonly shift: string,
    readonly startBreak: string,
    readonly endBreak: string,
    readonly duration: string,
    readonly deductionCapacity : string,
    readonly comment: string
  ) {}

  static createFromResponse (responseData: ShiftBreakResponse[]): Array<ShiftBreak> {
    let result: Array<ShiftBreak> = []
    if (responseData) {
      let i = 0
      result = responseData.map((data: any) => {
        return new ShiftBreak(
          ++i,
          data.Schicht ? data.Schicht.toString() : '',
          moment(data.Start, 'HH:mm:ss').format('HH:mm'),
          moment(data.Ende, 'HH:mm:ss').format('HH:mm'),
          moment.utc(data.DauerG *60 * 1000).format('HH:mm'),
          moment.utc(data.AbzugKapazitaet *60 * 1000).format('HH:mm'),
          data.Bemerkungen
        )
      })
    }
    return result
  }

  static create (id: number, shift: string, startBreak: string, endBreak: string, duration: string, deductionCapacity: string, comment: string): ShiftBreak {
      return new ShiftBreak(
        id,
        shift,
        startBreak,
        endBreak,
        duration,
        deductionCapacity,
        comment
      )
  }
}
